var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgCompanySegmentProspectsSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "CompanySegmentProspectsSmall_svg__[object_Object]a",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7793FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1877F2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#CompanySegmentProspectsSmall_svg__[object_Object]a)",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE4FE",
    d: "M11.862 12c.702 0 1.335.426 1.599 1.076a1.184 1.184 0 011.063 0 1.727 1.727 0 013.19-.024c.39.145.716.42.924.78l1.198 2.269c.367.974.102 2.072-.627 2.814a2.673 2.673 0 01-4.436-2.735.874.874 0 00-1.571 0c.037.106.068.215.091.325a2.707 2.707 0 01.04.788 2.672 2.672 0 11-4.875-1.749l.934-1.703a1.78 1.78 0 01.871-.765 1.726 1.726 0 011.6-1.076zM7.45 14.894A3.79 3.79 0 007.36 19H6.5A1.5 1.5 0 015 17.5v-1A1.5 1.5 0 016.5 15l.882-.001.068-.105zm4.972 1.743c-.27-.871-1.18-1.403-2.106-1.23-.925.174-1.563.997-1.474 1.902.088.906.875 1.598 1.818 1.602 1.014.001 1.837-.79 1.84-1.768 0-.171-.026-.342-.078-.506zm4.912-1.262c-.809.002-1.522.514-1.758 1.261a1.675 1.675 0 00-.076.508c.003.977.823 1.767 1.834 1.767a1.833 1.833 0 001.651-.998c.306-.613.22-1.34-.219-1.871l-.095-.112a1.882 1.882 0 00-1.337-.555zM15.5 5A1.5 1.5 0 0117 6.5l.001 4.423a2.82 2.82 0 00-.847-.123l-.17.007a2.823 2.823 0 00-1.889.908l-.052.06-.05-.002-.051.002-.056-.064a2.821 2.821 0 00-2.076-.911l-.171.005a2.822 2.822 0 00-2.21 1.302l-.04.067-.122.076c-.3.2-.559.453-.765.75H6.5A1.5 1.5 0 015 11.5v-5A1.5 1.5 0 016.5 5h9zm-4 4h-4a.5.5 0 00-.09.992L7.5 10h4a.5.5 0 100-1zm3-2h-7a.5.5 0 00-.09.992L7.5 8h7a.5.5 0 100-1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySegmentProspectsSmall);
export default ForwardRef;